class FormFiller {
    constructor() {
        this.formList = Array.from(document.querySelectorAll('.js-fill-form'));

        this.initialize();
    }
    initialize() {
        this.formList.map(form => {
            const changeDataButtons = Array.from(form.querySelectorAll('.js-fill-form-button'));
            const formId = form.id;

            this.bindFormFillButtons(changeDataButtons, formId);
        });
    }
    bindFormFillButtons(buttons, formId) {
        buttons.map(button => {
            button.addEventListener('click', () => this.fillForm(button, formId));

            this.prefillText(button, formId);
        })
    }
    fillForm(button, formId) {
        const options = JSON.parse(button.dataset.options);

        for (let option in options) {
            const value = options[option];
            const field = document.querySelector(`#${formId}_${option}`);

            this.fillText(`${formId}_${option}`, value);

            if (!!field) {
                switch (field.nodeName) {
                    case 'INPUT':
                    case 'TEXTAREA':
                        if (field.type !== 'radio' || field.type !== 'checkbox') field.value = value;
                        break;

                    case 'SELECT':
                        field.value = value;
                        break;
                }
            }
        }
    }
    fillText(name, value) {
        const textFields = Array.from(document.querySelectorAll(`[data-fill-form-text="${name}"]`));

        if (textFields) {
            textFields.map(field => field.innerHTML = value);
        }
    }
    prefillText(button, formId) {
        const options = JSON.parse(button.dataset.options);

        for (let option in options) {
            const field = document.querySelector(`#${formId}_${option}`);

            if (field && !!field.value) {
                this.fillText(field.id, field.value);
                this.removeErrors(formId);
            }
        }
    }
    removeErrors(formId) {
        const error = document.querySelector(`[data-fill-form-error="${formId}"]`);

        if (error) error.outerHTML = '';
    }
}

new FormFiller();
